export enum AssetTypes {
  EXTERNAL_CENTER_IMAGE = 'EXTERNAL_CENTER_IMAGE',
  CENTER_IMAGE = 'CENTER_IMAGE',
  PATTERN = 'PATTERN',
  ICON = 'ICON',
  CONTAINER = 'CONTAINER',
  EYES = 'EYES',
  FILE = 'FILE'
}
